import { Component, Input, TemplateRef } from "@angular/core";
import { NzDividerComponent } from "ng-zorro-antd/divider";
import { UiDividerTextOrientation, UiDividerType } from "./divider.models";

/**
 * This component extends the base Divider directive of NG-Zorro
 * Example usage : https://ng.ant.design/components/divider/en
 *
 * @param dividerDashed boolean (default: false)
 * @param dividerType 'horizontal' | 'vertical' (default: 'default')
 * @param dividerText	string | TemplateRef<void> - Inner text of divider ( --- text | html element --- )
 * @param dividerPlain boolean (default: false) - Divider text show as plain style
 * @param dividerTextOrientation "center" | "left" | "right" (default: "center") - Inner text orientation
 *
 */

@Component({
  templateUrl: "./divider.component.html",
  selector: "ui-divider",
})
export class UiDividerComponent extends NzDividerComponent {
  @Input("uiDashed")
  public nzDashed = false;

  @Input("uiType")
  public nzType: UiDividerType;

  @Input("uiText")
  public nzText: string | TemplateRef<void>;

  @Input("uiPlain")
  public nzPlain = false;

  @Input("uiTextOrientation")
  public nzOrientation: UiDividerTextOrientation;
}
